import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BlurredUntilReviewedProps {
  reviewing: boolean
  /** What sits over the blurred part, if anything: the review confirmation. */
  card?: ReactNode
  children: ReactNode
}

/** Blurred and out of reach until the customer confirms, with the review card over it; clears in place. */
export function BlurredUntilReviewed({ reviewing, card, children }: BlurredUntilReviewedProps) {
  return (
    // One grid cell for both, so the area is as tall as the board or the card, whichever is taller.
    <div className="grid">
      <div
        inert={reviewing}
        aria-hidden={reviewing || undefined}
        className={cn(
          'min-w-0 transition-[filter] duration-700 [grid-area:1/1]',
          reviewing && 'pointer-events-none blur-md select-none'
        )}
      >
        {children}
      </div>
      {reviewing && card && (
        <div className="z-10 flex items-start justify-center px-4 pt-8 [grid-area:1/1] sm:pt-16">{card}</div>
      )}
    </div>
  )
}
